"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultOptions = {
    billionPostfix: 'млрд.',
    fractionalLength: 2,
    millionPostfix: 'млн.',
    separator: undefined,
    thousandPostfix: 'тыс.',
    withoutPostfix: false,
};
function shortenNumber(i, userOptions) {
    var options = userOptions
        ? Object.assign({}, defaultOptions, userOptions)
        : defaultOptions;
    var getFractional = fractional(options.fractionalLength);
    var applyPostfix = options.withoutPostfix
        ? withoutPostfix(options.separator)
        : withPostfix(options.separator);
    if (i >= 1000000000) {
        var value = getFractional(i, 1000000000);
        return applyPostfix(value, options.billionPostfix);
    }
    else if (i >= 1000000) {
        var value = getFractional(i, 1000000);
        return applyPostfix(String(value), options.millionPostfix);
    }
    else if (i >= 1000) {
        var value = getFractional(i, 1000);
        return applyPostfix(value, options.thousandPostfix);
    }
    else {
        var value = getFractional(i);
        return applySeparator(Number(value), options.separator);
    }
}
exports.shortenNumber = shortenNumber;
function withPostfix(separator) {
    return function (value, postfix) {
        return applySeparator(Number(value), separator) + " " + postfix;
    };
}
function withoutPostfix(separator) {
    return function (value) {
        return applySeparator(Number(value), separator);
    };
}
function fractional(fractionalLength) {
    return function (value, divider) {
        if (!divider) {
            return value.toFixed(fractionalLength);
        }
        var num = value / divider;
        var numAsArray = String(num).split('.');
        var originalFractionChapter = numAsArray[1];
        if (originalFractionChapter &&
            originalFractionChapter.length > 2 &&
            Number(originalFractionChapter.slice(-1)) < 5) {
            return num.toFixed(fractionalLength);
        }
        else if (originalFractionChapter) {
            var newFractionChapter = originalFractionChapter.length > fractionalLength
                ? originalFractionChapter.slice(0, fractionalLength)
                : originalFractionChapter;
            return numAsArray[0] + "." + newFractionChapter;
        }
        return String(num);
    };
}
function applySeparator(value, separator) {
    if (typeof separator === 'string') {
        return value.toString().replace('.', separator);
    }
    return value.toString();
}



//////////////////
// WEBPACK FOOTER
// ./src/shared/shorten_number.ts
// module id = 11
// module chunks = 0